// extracted by mini-css-extract-plugin
export default {"Octicon":"BypassAvatar-module__Octicon__cjNaFTr"};